var React = require('react');
var ReactNative = require('react-native');

var {
  AppRegistry,
  View,
  StyleSheet,
  Animated,
} = ReactNative;

import Svg, {
    Path,
    G,
    Circle
} from './wrappers/react-native-svg-wrapper';

function polarToCartesian(centerX, centerY, radius, angleInDegrees)
{
  var angleInRadians = angleInDegrees * Math.PI / 180.0;
  var x = centerX + radius * Math.cos(angleInRadians);
  var y = centerY + radius * Math.sin(angleInRadians);
  return [x,y];
}

function svgArc(startAngle, endAngle, percentage, dimension)
{
  if( percentage <= 0 ) return null;
  var anglesStartedEqual = startAngle == endAngle;

  while(startAngle < 0) startAngle += 360;
  while(endAngle < 0 || endAngle < startAngle) endAngle += 360;

  if( percentage == 1 && startAngle == endAngle ) endAngle += 359;

  var portionAngle = parseFloat((endAngle - startAngle))*(percentage);
  var stopAngle = startAngle+portionAngle;

  var center = dimension/2;
  var dist = 4*dimension/10;
  var [sx,sy] = polarToCartesian(center, center, dist, startAngle%360);
  var [ex,ey] = polarToCartesian(center, center, dist, stopAngle);

  var flag = (stopAngle-startAngle)%360 < 180 ? "0" : "1";
  console.log("svgArc","M "+ex+" "+ey+" A "+dist+" "+dist+" 0 "+flag+" 0 "+sx+" "+sy)
  return "M "+ex+" "+ey+" A "+dist+" "+dist+" 0 "+flag+" 0 "+sx+" "+sy;
}

var MAX_FIRST_PART = .3;
function svgCheckMark(percentage, dimension)
{
  if( percentage <= 0 ) return null;
  var percentageFirstPart = Math.min(1, percentage/MAX_FIRST_PART);

  var startX = (1/5)*dimension;
  var startY = (1/2)*dimension;
  var end1X = startX + percentageFirstPart*((2/5)*dimension - startX);
  var end1Y = startY + percentageFirstPart*((7/10)*dimension - startY);
  var end2X = end1X;
  var end2Y = end1Y;
  if( percentage > .3 )
  {
    var percentageSecondPart = Math.max(0, (percentage - MAX_FIRST_PART)/(1 - MAX_FIRST_PART));
    end2X = end1X + percentage*((15/20)*dimension - end1X);
    end2Y = end1Y + percentage*((7/20)*dimension - end1Y);
  }
  var d = "M "+startX+" "+startY+" L "+end1X+" "+end1Y;
  if( percentage > .3 ) d += " L "+end2X+" "+end2Y;
    console.log("svgCheckMark",d)
  return d;
}


var CheckMarkView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      color : 'blue',
      thickness : 6,
    }
  },

  getInitialState : function()
  {
    return {
      progress : new Animated.Value(0),
      height : -1,
      width : -1,
      progressVal : 0
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    this.state.progress.addListener(({value}) =>
    {
      thisThing.setState({progressVal:value})
    });

    setTimeout(()=>
    {
      thisThing._hasDoneFirstSet = true;
      thisThing.setProgress(1);
    }, 500)
  },

  _hasDoneFirstSet : false,
  setProgress : function(newProgress)
  {
    if( !this._hasDoneFirstSet ) return;

    // Animated.spring(
    //   this.state.progress,
    //   {
    //     toValue: newProgress,
    //     tension: 4,
    //     friction: 7,
    //   },
    // ).start();

    Animated.timing(
     this.state.progress,
     {toValue: newProgress,
     duration:800},
    ).start(function()
    {

    });
  },

  render : function()
  {
    var dimension = Math.min(this.state.width, this.state.height);
    var {color, thickness, ...otherProps} = this.props;
    var ringSVG = svgArc(91, 89, this.state.progressVal, dimension);
    var checkSVG = svgCheckMark(this.state.progressVal, dimension);

    var thisThing = this;
console.log("ringSVG",ringSVG)
console.log("checkSVG",checkSVG)
    return (
      <View {...otherProps} onLayout={(evt)=>
        {
          thisThing.setState({height:evt.nativeEvent.layout.height, width:evt.nativeEvent.layout.width});
        }}>
        {
          this.state.width > 0 && this.state.height > 0 ?
            <View style={{width:dimension, height:dimension, backgroundColor:'transparent', alignSelf:'center'}}>
              <Svg
                height={dimension}
                width={dimension}
              >
                <G scale="1">
                {
                  ringSVG !== null ?
                    <Path
                      d={ringSVG}
                      stroke={color}
                      strokeWidth={thickness}
                      strokeLinecap={"round"}
                      fill="none"
                    />
                  : null
                }
                {
                  checkSVG !== null ?
                    <Path
                      d={checkSVG}
                      stroke={color}
                      strokeWidth={thickness-2}
                      strokeLinecap={"round"}
                      fill="none"
                    />
                  : null
                }
                </G>
              </Svg>
            </View>
          : null
        }
      </View>

    )
  }
})

module.exports = CheckMarkView;



// WEBPACK FOOTER //
// ./src/CheckMarkView.js